import React, { createContext, useContext, ReactNode } from "react";
import { useScreenCloud } from "../ScreenCloudReactApp";

export interface PulseContextValue {
  isPulse: boolean;
  isExclusive: boolean;
}

const defaultValue: PulseContextValue = { isPulse: false, isExclusive: false };

export const PulseContext = createContext<PulseContextValue>(defaultValue);

interface PulseProviderProps {
  children: ReactNode;
}

export const PulseProvider = ({
  children,
}: PulseProviderProps): JSX.Element => {
  const sc = useScreenCloud();
  const pulseConfig = (
    sc.config as unknown as {
      pulse?: { isExclusive?: boolean };
    }
  ).pulse;

  const screenDataIsPulseRaw = sc.context.screenData?.isPulse;
  const screenDataIsPulse =
    typeof screenDataIsPulseRaw === "string"
      ? screenDataIsPulseRaw.toLowerCase() === "true"
      : undefined;

  const isPulse = screenDataIsPulse ?? Boolean(pulseConfig);
  const isExclusive = Boolean(pulseConfig && pulseConfig.isExclusive);
  return (
    <PulseContext.Provider value={{ isPulse, isExclusive }}>
      {children}
    </PulseContext.Provider>
  );
};

export const usePulse = (): PulseContextValue => useContext(PulseContext);

export default PulseProvider;
